export enum MessageSender {
    User = "user",
    Moderator = "moderator",
    Assistant = "assistant"
}

